import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-53fde2b2")

_pushScopeId("data-v-53fde2b2")
const _hoisted_1 = { class: "rrn-wrapped" }
const _hoisted_2 = { class: "rrn p-confirm-dialog-custom p-dialog" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "p-dialog-header" }, [
  /*#__PURE__*/_createVNode("h3", { class: "-bold p-dialog-title" }, "주민등록번호 입력")
], -1)
const _hoisted_4 = { class: "p-dialog-content" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "p-confirm-dialog-message" }, " 환자의 건강보험 가입여부 및 요양급여비용 청구에만 사용되며, 2차 소견만을 이용하시는 경우 입력하지 않으셔도 됩니다. ", -1)
const _hoisted_6 = { class: "agree" }
const _hoisted_7 = /*#__PURE__*/_createVNode("h3", { class: "-bold" }, "고유식별정보 수집에 대한 별도 동의", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("ul", null, [
  /*#__PURE__*/_createVNode("li", null, [
    /*#__PURE__*/_createVNode("span", { class: "-bold" }, "고유식별정보의 수집·이용목적 :"),
    /*#__PURE__*/_createTextVNode(" 건강보험가입여부, 요양급여비용청구 등 건강보험에 이용 ")
  ]),
  /*#__PURE__*/_createVNode("li", null, [
    /*#__PURE__*/_createVNode("span", { class: "-bold" }, "고유식별정보 항목 :"),
    /*#__PURE__*/_createTextVNode(" 주민등록번호 ")
  ]),
  /*#__PURE__*/_createVNode("li", null, [
    /*#__PURE__*/_createVNode("span", { class: "-bold" }, "보유 및 이용기간 :"),
    /*#__PURE__*/_createTextVNode(" 서비스 탈퇴 시 까지 ")
  ])
], -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "-bold" }, [
  /*#__PURE__*/_createTextVNode(" 동의를 거부할 수 있으며 동의 거부시 "),
  /*#__PURE__*/_createVNode("span", { class: "-royalBlue" }, "온라인 대면진료"),
  /*#__PURE__*/_createTextVNode(" 서비스가 제공되지 않습니다. ")
], -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("label", null, "위 고유식별정보 수집이용에 동의하십니까?", -1)
const _hoisted_11 = {
  key: 0,
  class: "input__wrapped"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_13 = { class: "p-dialog-footer" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("취소")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("저장")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("닫기")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SelectButton = _resolveComponent("SelectButton")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Field = _resolveComponent("Field")
  const _component_Button = _resolveComponent("Button")
  const _component_Form = _resolveComponent("Form")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        class: "rrn__form",
        onSubmit: _ctx.save
      }, {
        default: _withId(({ errors }) => [
          _hoisted_3,
          _createVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode("div", _hoisted_6, [
              _hoisted_7,
              _hoisted_8,
              _hoisted_9,
              _createVNode("div", null, [
                _hoisted_10,
                _createVNode(_component_SelectButton, {
                  modelValue: _ctx.agree,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.agree = $event)),
                  options: ['Y', 'N'],
                  class: "agree"
                }, {
                  option: _withId((slotProps) => [
                    _createTextVNode(_toDisplayString(slotProps.option == "Y" ? "예" : "아니오"), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            (_ctx.agree === 'Y')
              ? (_openBlock(), _createBlock("div", _hoisted_11, [
                  _createVNode(_component_Field, {
                    modelValue: _ctx.rrn.rrn1,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.rrn.rrn1 = $event)),
                    name: "rrn1",
                    rules: "required|rrn1"
                  }, {
                    default: _withId(({ field }) => [
                      _createVNode(_component_InputText, _mergeProps({
                        id: "rrn1",
                        placeholder: "주민등록번호 앞자리",
                        modelValue: field.value,
                        "onUpdate:modelValue": ($event: any) => (field.value = $event)
                      }, field, {
                        class: { 'p-invalid': errors.rrn1 },
                        type: "text"
                      }), null, 16, ["modelValue", "onUpdate:modelValue", "class"])
                    ]),
                    _: 2
                  }, 1032, ["modelValue"]),
                  _hoisted_12,
                  _createVNode(_component_Field, {
                    modelValue: _ctx.rrn.rrn2,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.rrn.rrn2 = $event)),
                    name: "rrn2",
                    rules: "required|rrn2"
                  }, {
                    default: _withId(({ field }) => [
                      _createVNode(_component_InputText, _mergeProps({
                        id: "rrn2",
                        placeholder: "주민등록번호 뒷자리",
                        modelValue: field.value,
                        "onUpdate:modelValue": ($event: any) => (field.value = $event)
                      }, field, {
                        type: "password",
                        class: { 'p-invalid': errors.rrn2 }
                      }), null, 16, ["modelValue", "onUpdate:modelValue", "class"])
                    ]),
                    _: 2
                  }, 1032, ["modelValue"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_13, [
            (_ctx.agree === 'Y')
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_Button, {
                    class: "-button -waikawaGrey",
                    type: "button",
                    onClick: _ctx.close
                  }, {
                    default: _withId(() => [
                      _hoisted_14
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_Button, {
                    class: "-button -royalBlue",
                    type: "submit"
                  }, {
                    default: _withId(() => [
                      _hoisted_15
                    ]),
                    _: 1
                  })
                ], 64))
              : (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  class: "-button -royalBlue",
                  type: "button",
                  onClick: _ctx.close
                }, {
                  default: _withId(() => [
                    _hoisted_16
                  ]),
                  _: 1
                }, 8, ["onClick"]))
          ])
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ])
  ]))
})